<template>
  <div class="vp-ticket-sales-metric">
    <div class="vp-content">
      <div class="vp-header">
        <div class="vp-title">
          {{ $gettext(title) }}
        </div>
        <div class="vp-today">
          <span class="vp-label">{{ $gettext('Today:') }} </span>
          <span class="vp-value">{{ today }}</span>
        </div>
      </div>
      <div class="vp-summary">
        <span class="vp-label">{{ $gettext('Total:') }} </span>
        <span class="vp-value">{{ total }}</span>
      </div>
    </div>
    <div class="vp-chart">
      <VPPercentageChart :percent="percent" />
    </div>
  </div>
</template>

<script setup lang="ts">
import VPPercentageChart from '@/components/form/VPPercentageChart.vue';
import { useGettext } from 'vue3-gettext';

const { $gettext } = useGettext();

type Props = {
  title: string;
  today: string;
  total: string;
  percent: number;
};

defineProps<Props>();
</script>
